module.exports = require('./dist/suspense-context');
